import { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Recognition from "@/components/site/Recognition";
import Approach from "@/components/site/Approach";
import Expertise from "@/components/site/Expertise";
import Services from "@/components/site/Services";
import GroupConstellations from "@/components/site/GroupConstellations";
import AboutPreview from "@/components/site/AboutPreview";
import Credibility from "@/components/site/Credibility";
import LeadMagnet from "@/components/site/LeadMagnet";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";

export default function HomePage() {
  const [bookingOpen, setBookingOpen] = useState(false);

  const openBooking = () => setBookingOpen(true);

  return (
    <div className="min-h-screen bg-[#FAF7F8] text-[#1E1E2A]" data-testid="home-page">
      <Navbar onBookingClick={openBooking} />
      <main>
        <Hero onBookingClick={openBooking} />
        <Recognition />
        <Approach />
        <Expertise />
        <Services onBookingClick={openBooking} />
        <GroupConstellations onBookingClick={openBooking} />
        <AboutPreview />
        <Credibility />
        <LeadMagnet />
        <FAQ />
        <FinalCTA onBookingClick={openBooking} />
      </main>
      <Footer />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
    </div>
  );
}
